export default {
  ja: "+81"
};
